export var ContextGLBlendFactor;
(function (ContextGLBlendFactor) {
    ContextGLBlendFactor[ContextGLBlendFactor["DESTINATION_ALPHA"] = 0] = "DESTINATION_ALPHA";
    ContextGLBlendFactor[ContextGLBlendFactor["DESTINATION_COLOR"] = 1] = "DESTINATION_COLOR";
    ContextGLBlendFactor[ContextGLBlendFactor["ONE"] = 2] = "ONE";
    ContextGLBlendFactor[ContextGLBlendFactor["ONE_MINUS_DESTINATION_ALPHA"] = 3] = "ONE_MINUS_DESTINATION_ALPHA";
    ContextGLBlendFactor[ContextGLBlendFactor["ONE_MINUS_DESTINATION_COLOR"] = 4] = "ONE_MINUS_DESTINATION_COLOR";
    ContextGLBlendFactor[ContextGLBlendFactor["ONE_MINUS_SOURCE_ALPHA"] = 5] = "ONE_MINUS_SOURCE_ALPHA";
    ContextGLBlendFactor[ContextGLBlendFactor["ONE_MINUS_SOURCE_COLOR"] = 6] = "ONE_MINUS_SOURCE_COLOR";
    ContextGLBlendFactor[ContextGLBlendFactor["SOURCE_ALPHA"] = 7] = "SOURCE_ALPHA";
    ContextGLBlendFactor[ContextGLBlendFactor["SOURCE_COLOR"] = 8] = "SOURCE_COLOR";
    ContextGLBlendFactor[ContextGLBlendFactor["ZERO"] = 9] = "ZERO";
})(ContextGLBlendFactor || (ContextGLBlendFactor = {}));



// WEBPACK FOOTER //
// ../dist/lib/base/ContextGLBlendFactor.js